import type zh from '../zh/workspace';

/**
 * Frozen copy of the workspace text the UI showed before the zh/en switch, rendered while
 * UI_I18N_ENABLED is off (gamma / prod). Do not edit the text; add a key here only when
 * zh gains one, with the text the UI would show without the switch. Delete with the flag.
 */
const workspace: typeof zh = {
  nav: {
    label: 'Workspace navigation',
    title: 'Workspace',
    resize: '拖动调整宽度，双击恢复默认',
    collapse: 'Collapse',
    collapseLabel: 'Collapse workspace panel',
    search: 'Search',
    searchLabel: 'Search workspace',
    recent: 'Recent',
    loading: 'Loading workspace...',
    loadFailed: 'Failed to load workspace',
    empty: 'No items in workspace',
    emptyFolder: 'No items',
    noMatches: 'No matching items',
  },
  home: {
    busy1: '☕ Rocky 正在思考中，喝口茶稍等一下~',
    busy2: '🧠 Rocky 还在忙，让它先回完再说~',
    busy3: '⏳ 等 Rocky 回复完再点，别急~',
    busy4: '🍵 Rocky 专注中，稍后再来~',
    readOnly: '👀 当前为 Admin 查看模式，无法操作',
    queueFull: '待发送队列最多 3 条',
    promptsLink: 'Rocky按情景Prompt合集 · 复制就能用',
    guideLink: 'CMHK AI Agents 选用指南',
    badgeNew: 'NEW',
    badgeHot: 'HOT',
  },
  viewer: {
    loading: 'Loading report...',
    loadImageFailed: 'Failed to load image',
    loadReportFailed: 'Failed to load report',
    cannotPreview: 'This file type cannot be previewed',
    download: 'Download',
    downloading: 'Downloading...',
    downloadTitle: 'Download report',
    downloadFailed: 'Download failed. Please try again.',
    csvTruncated: '显示前 {{shown}} 行，共 {{total}} 行 — 其余请下载查看',
    csvTotal: '共 {{total}} 行',
  },
  openFile: {
    noAccess: '无法在 Rocky 工作区打开该文件：当前账号不在 {{groups}} LDAP 组中。\n\n请通过以下链接申请访问权限：\n{{url}}',
  },
};

export default workspace;
